import { createSlice } from '@reduxjs/toolkit';

const { createContext, useContext } = require('react');

/**
 * @type {{
 *  open: boolean;
 *  view: 'login' | 'signup' | 'verify-email' | 'forgot-password';
 * }} initialState
 */
export const authContextInitialState = {
  open: false,
  view: 'signup',
};

export const authContextSlice = createSlice({
  name: 'authContextSlice',
  initialState: authContextInitialState,
  reducers: {
    /**
     * @param {{payload: boolean}} action
     */
    setOpen: (state, action) => {
      state.open = action.payload;
    },

    /**
     * @param {{payload: typeof authContextInitialState.view}} action
     */
    setView: (state, action) => {
      state.view = action.payload;
    },
  },
});

const AuthContext = createContext({ authCtx: authContextInitialState, dispatchAuthCtx: null });
AuthContext.displayName = 'AuthContext';

export const useAuthContext = () => useContext(AuthContext);

export default AuthContext;
